<div class="container h-full">
  <shared-title class="flex align-items-center justify-content-center">
    <strong>{{ operation }}</strong>
  </shared-title>
  <div
    class="flex-column ms:flex-column md: flex-column lg:flex-row xl:flex-row"
    [ngClass]="
      this.data?.action.idGroup
        ? 'flex align-items-center justify-content-center pt-5 '
        : 'flex align-items-center justify-content-center w-12  gap-2  h-30rem '
    ">
    <mat-card
      [ngClass]="
        this.data?.action.idGroup
          ? 'w-9 h-17rem'
          : 'h-9 mt-8 sm:mt-8 md:mt-4 lg:mt-0 xl:mt-0 sm:h-5 md:h-full lg:h-full xl:h-full w-full sm:w-full md:w-11 lg:w-7 xl:w-7 flex justify-content-center'
      ">
      <mat-card-content class="flex align-items-center justify-content-center">
        <form
          [formGroup]="workerWorkPlaceGroupForm"
          class="flex flex-column w-full align-items-center">
          <mat-form-field class="w-full" appearance="fill">
            <mat-label>Grupo de usuarios </mat-label>
            <mat-select
              formControlName="workerGroupId"
              (valueChange)="chargueDataSource($event)">
              @for (group of groupsUser; track group) {
                <mat-option
                  [value]="group.id"
                  (onSelectionChange)="nameGroupUserSelected = group.name">
                  {{ group.name }}
                </mat-option>
              }
            </mat-select>
            @if (
              workerWorkPlaceGroupForm.controls['workerGroupId'].hasError(
                'required'
              )
            ) {
              <mat-error>
                <small>Grupo de Usuarios es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-full" appearance="fill">
            <mat-label>Grupo de puestos</mat-label>
            <mat-select formControlName="workplaceGroupId">
              @for (group of groupsWork; track group) {
                <mat-option [value]="group.id">
                  {{ group.name }}
                </mat-option>
              }
            </mat-select>
            @if (
              workerWorkPlaceGroupForm.controls['workplaceGroupId'].hasError(
                'required'
              )
            ) {
              <mat-error>
                <small
                  >Grupo de puestos de Trabajo es <strong>requerida</strong>
                </small>
              </mat-error>
            }
          </mat-form-field>
          <div
            class="w-full gap-2 flex justify-content-evenly mb-3 flex-column md:flex-row lg:flex-row xl:flex-row">
            <shared-button
              mat-dialog-close
              [icon]="'clear'"
              [typeBtn]="'button'"
              [color]="'warn'"
              >Cancelar
            </shared-button>
            <shared-button
              [disabled]="!workerWorkPlaceGroupForm.valid"
              [icon]="'save_alt'"
              [typeBtn]="'submit'"
              [color]="'accent'"
              (click)="submit()">
              {{ operation }}
            </shared-button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
    <div>
      @if (!this.data?.action.idGroup) {
        <mat-card
          class="h-full flex w-full sm:w-full md:w-full lg:w-7 xl:w-full lg:h-30rem xl:h-30rem flex-column align-items-center overflow-auto">
          <mat-card-content>
            <h2 matDialogTitle>
              Grupo de Usuarios: <strong>{{ nameGroupUserSelected }}</strong>
            </h2>
            <div class="shadow-2 overflow-auto">
              <table mat-table [dataSource]="dataSource" matSort>
                <!-- Name Column -->
                <ng-container matColumnDef="name" sticky>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Nombre
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <!-- Description Column -->
                <ng-container matColumnDef="description" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Descripción
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
            <br />
            <mat-paginator
              [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons
              aria-label="Select page of periodic elements">
            </mat-paginator>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>
